// BBA / Chulalongkorn Business School Design System tokens
// Source of truth: design-system/bba-cbs-design-system.md
//
// Primary:   #56A1F5 (BBA light blue) — observed on the live APPLY NOW CTA
// Secondary: #13267F (BBA navy)       — headings, strong text, high-contrast UI
// Tertiary:  #0D1E6A (deep navy)       — dark sections, footer, high-emphasis actions
// Accent:    #00A1DF (CBS sky blue)    — focus rings, ribbons, active indicators
// Neutral:   #F8FAFC (off-white)       — page surface, card background
//
// NOTE: Do NOT use Chula Pink / hot pink for BBA/CBS UI states.
// NOTE: Use tertiary text on primary; avoid white text on light blue.

export const BBA_PRIMARY = '#56A1F5';
export const BBA_PRIMARY_DARK = '#2F82DD';
export const BBA_PRIMARY_LIGHT = '#B7DAFF';

export const BBA_SECONDARY = '#13267F';
export const BBA_SECONDARY_DARK = '#0D1E6A';
export const BBA_SECONDARY_LIGHT = '#DDE8FA';

export const BBA_TERTIARY = '#0D1E6A';
export const BBA_TERTIARY_DARK = '#071441';
export const BBA_TERTIARY_LIGHT = '#4E6FBE';

export const BBA_ACCENT = '#00A1DF';
export const BBA_ACCENT_DARK = '#008FCA';
export const BBA_ACCENT_LIGHT = '#D8F0FB';

export const BBA_NEUTRAL = '#F8FAFC';

// Neutral scale
export const NEUTRAL_100 = '#F1F5F9';
export const NEUTRAL_200 = '#E4E4E7';
export const NEUTRAL_400 = '#A1A1AA';
export const NEUTRAL_600 = '#52525B';
export const NEUTRAL_900 = '#18181B';

// Semantic
export const COLOR_SUCCESS = '#168A4A';
export const COLOR_WARNING = '#B7791F';
export const COLOR_DANGER = '#C62828';
export const COLOR_INFO = '#00A1DF';

// Brand font stacks
// Body / labels — Poppins (mirrors mobile bba_theme body/label font)
export const FONT_FAMILY = [
  'Poppins',
  '"Noto Sans Thai"',
  'Inter',
  'sans-serif',
].join(',');

// Headlines / page titles — EB Garamond (serif), mirrors mobile bba_theme
// headline font. Thai falls back to Noto Sans Thai (EB Garamond has no Thai).
export const HEADING_FONT_FAMILY = [
  '"EB Garamond"',
  '"Noto Sans Thai"',
  'Georgia',
  'serif',
].join(',');
